// extracted by mini-css-extract-plugin
export default {"customconfigsection":"customconfigsection_cd2d04f09e12d148016d"};